<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>退款管理</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select v-model="queryParams.refundStatus" placeholder="请选择状态" clearable>
            <el-option label="申请中" :value="0" />
            <el-option label="已同意" :value="1" />
            <el-option label="已拒绝" :value="2" />
            <el-option label="已完成" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="refundList">
        <el-table-column label="退款ID" align="center" prop="id" width="80" />
        <el-table-column label="订单号" align="center" prop="orderNo" width="180" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="退款金额" align="center" prop="refundAmount" width="120" />
        <el-table-column label="退款原因" align="center" prop="reason" show-overflow-tooltip />
        <el-table-column label="退款状态" align="center" prop="refundStatus" width="100">
          <template slot-scope="scope">
            <el-tag :type="getRefundStatusType(scope.row.refundStatus)">
              {{ getRefundStatusText(scope.row.refundStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.refundStatus === 0" size="mini" type="success" @click="handleApprove(scope.row)">同意</el-button>
            <el-button v-if="scope.row.refundStatus === 0" size="mini" type="danger" @click="handleReject(scope.row)">拒绝</el-button>
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RefundManage',
  data() {
    return {
      loading: true,
      total: 0,
      refundList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: undefined,
        refundStatus: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取退款列表
      setTimeout(() => {
        this.refundList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getRefundStatusType(status) {
      const types = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' }
      return types[status] || ''
    },
    getRefundStatusText(status) {
      const texts = { 0: '申请中', 1: '已同意', 2: '已拒绝', 3: '已完成' }
      return texts[status] || '未知'
    },
    handleApprove(row) {
      this.$message.info('同意退款功能待实现')
    },
    handleReject(row) {
      this.$message.info('拒绝退款功能待实现')
    },
    handleView(row) {
      this.$message.info('查看详情功能待实现')
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
